export default __webpack_public_path__ + "static/media/Sorcerer's Bracers of Imperial Assent.e6a02524.jpg";